(function ($, Drupal, once) {
    'use strict';
  
    Drupal.behaviors.accountDeletion = {
      attach: function (context, settings) {
        once('account-deletion', $('#delete-account-btn', context)).forEach(function(element) {
          $(element).on('click', function (e) {
            e.preventDefault();
    
            // // Créer la popup de confirmation
            // const $dialog = $('<div id="account-deletion-dialog"></div>');
            // $dialog.append('<p>' + Drupal.t('Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.') + '</p>');
            
            // // Ajouter les boutons
            // const $buttonsContainer = $('<div class="dialog-buttons"></div>');
            
            // const $cancelButton = $('<button class="btn btn-secondary">' + Drupal.t('Annuler') + '</button>');
            // $cancelButton.on('click', function() {
            //   $dialog.dialog('close');
            // });
            
            // const $confirmButton = $('<button class="btn btn-danger">' + Drupal.t('Supprimer mon compte') + '</button>');
            // $confirmButton.on('click', function() {
            //   window.location.href = Drupal.url('api/passpass_anonymisation');
            // });
            
            // $buttonsContainer.append($cancelButton);
            // $buttonsContainer.append($confirmButton);
            // $dialog.append($buttonsContainer);
            
            // // Ouvrir la popup
            // $dialog.dialog({
            //   title: Drupal.t('Confirmation de suppression de compte'),
            //   modal: true,
            //   width: 'auto',
            //   resizable: false,
            //   id: 'account-deletion-dialog',
            //   close: function() {
            //     $(this).dialog('destroy').remove();
            //   }
            // });
            const elementBtnDelete = document.getElementById('btn-delete-account-modal');
            if(elementBtnDelete) elementBtnDelete.click();
          });
        });
      }
    };
  
  })(jQuery, Drupal, once);